import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  errorMessage: null,
  saving: false
};

const EventSongEditSlice = createSlice({
  name: "EventSongEdit",
  initialState,
  reducers: {
    eventSongEditSaving(state) {
      state.saving = true;
      state.errorMessage = null;
    },
    eventSongEditSuccess(state) {
      state.success = true;
      state.saving = false;
    },
    eventSongEditError(state, action) {
      state.errorMessage = action.payload;
      state.saving = false;
    },
    eventSongEditReset(state) {
      state.success = false;
      state.errorMessage = null;
      state.saving = false;
    }
  },
});

export const {
  eventSongEditSaving,
  eventSongEditSuccess,
  eventSongEditError,
  eventSongEditReset
} = EventSongEditSlice.actions

export default EventSongEditSlice.reducer;
